module.exports = __webpack_public_path__ + "static/media/applicants.fb37e94c.svg";